<template>
  <div v-if="data">
    <div
      v-for="(creditor, index) in data"
      :key="creditor + index + Math.random()"
    >
      <div class="form-base__title preview break">
        {{ `Кредитор №${index + 1}` }}
      </div>

      <div class="row-box mb-5">
        <Person :data="creditor" v-if="creditor.person" />
        <Organization :data="creditor" v-if="creditor.organization" />
        <ForeignOrganization
          :data="creditor"
          v-if="creditor.foreignOrganization"
        />

        <SubjectDetails :data="creditor.details" />
      </div>
    </div>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import Person from '@/components/elements/statement/FullStatementView/elements/Person';
import Organization from '@/components/elements/statement/FullStatementView/elements/Organization';
import ForeignOrganization from '@/components/elements/statement/FullStatementView/elements/ForeignOrganization';
import SubjectDetails from '@/components/elements/statement/FullStatementView/elements/SubjectDetails';

export default {
  name: 'Step2',
  components: {
    ForeignOrganization,
    Organization,
    Person,
    SubjectDetails,
  },
  props: ['data'],
  data: () => ({
    createDataField,
  }),
};
</script>
